namespace RS.Translations
{
	/** Contains the list of all supported locales. */
	export const supportedLocaleCodes: ReadonlyArray<string> = 
	[
		"bg_BG","ca_ES","cs_CZ","da_DK","de_DE","el_GR","en_GB","en_US","es_ES","et_EE","fi_FI","fr_CA","fr_FR","hr_HR","hu_HU","it_IT","ja_JP","lt_LT","lv_LV","nl_NL","no_NO","pl_PL","pt_PT","ro_RO","ru_RU","sk_SK","sl_SI","sr_RS","sr_SR","sv_SE","tr_TR"];
	/** The default locale that should be used in the event that the game fails to select an appropriate locale from supportedLocaleCodes */
	export let defaultLocaleCode = "en_GB";
}